import * as stylex from '@stylexjs/stylex';
import '../../styles/tokens.stylex';
import { borderRadius, iconColor, iconFeature, size, spacing, typographyColor } from '../../styles/tokens.stylex';
export const iconsStyles = {
  darkElement: {
    kDwRjp: "x3zd1ms",
    $$css: true
  },
  lightElement: {
    kDwRjp: "x1imn8ix",
    $$css: true
  },
  primaryElement: {
    kDwRjp: "x14ml95x",
    $$css: true
  },
  backgroundElement: {
    kDwRjp: "x179a343",
    $$css: true
  },
  goldElement: {
    kDwRjp: "x1ksblu5",
    $$css: true
  },
  greenElement: {
    kDwRjp: "xcsq0p6",
    $$css: true
  },
  neutralElement: {
    kDwRjp: "xwlrcrf",
    $$css: true
  },
  iconFrame: {
    kaIpWk: "x1lmuu4b",
    kWkggS: "x1fgy5gy",
    kZKoxP: "x1fed9y0",
    kzqmXN: "x1oe1w24",
    kmVPX3: "x1w3mzuc",
    kmuXW: "x2lah0s",
    $$css: true
  }
};
export const IconsSizes = {
  regular: {
    kZKoxP: "x1fju8i8",
    kzqmXN: "x1tjwh29",
    $$css: true
  },
  small: {
    kZKoxP: "xbhzzc1",
    kzqmXN: "xloivkj",
    $$css: true
  },
  xsmall: {
    kZKoxP: "xqwie1i",
    kzqmXN: "xs02qll",
    $$css: true
  }
};